import { CreatePostTemplate, EditPostTemplate, PostTemplate } from './../models/inModels/PostTemplate';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggingService } from './logging/logging.service';
import { AuthenticationService } from './authentication/authentication.service';
import { LazyLoadEvent } from '../models/DataTables/lazyLoadEvent';

@Injectable()
export class PostTemplateService {
  private route = '/api/post/template';
  constructor(
    private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
  ) { }

  search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
  }
  
  get(id: number): Promise<PostTemplate> {
    return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
      .toPromise()
      .then(response => response as PostTemplate)
      .catch(error => this.logging.handleError(error));
  }

  create(user: CreatePostTemplate): Promise<PostTemplate> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as PostTemplate)
			.catch(error => this.logging.handleError(error));
  }


  delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
  }

  update(user: EditPostTemplate): Promise<PostTemplate> {
    return this.http.post(`${this.auth.apiUrl}${this.route}/update`, JSON.stringify(user), { headers: this.auth.header })
      .toPromise()
      .then(response => response as PostTemplate)
      .catch(error => this.logging.handleError(error));
    }

}



// WEBPACK FOOTER //
// ./src/app/services/post-template.service.ts